import Textarea from "./textarea";
import TextInput from "./textinput";

export { Textarea, TextInput };
